import attachment from './attachment'

const AttachmentServer = {
    attachment,
};

export default AttachmentServer;
